var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E7F",
    d: "M28.5 17c0 6.904-5.596 12.5-12.5 12.5S3.5 23.904 3.5 17 9.096 4.5 16 4.5 28.5 10.096 28.5 17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.888 18.643a1.1 1.1 0 0 1-.782-.34 1.18 1.18 0 0 1-.33-.803v-6.857c0-.303.118-.594.326-.808s.491-.335.786-.335c.294 0 .577.12.785.335.209.214.326.505.326.808V17.5c-.004.302-.122.59-.33.804a1.1 1.1 0 0 1-.781.339M15.888 22.833c.818 0 1.481-.682 1.481-1.523 0-.842-.663-1.524-1.481-1.524s-1.482.682-1.482 1.523c0 .842.663 1.524 1.482 1.524"
  })));
};
export default SvgError;